import { ColumnFiltersState } from '@tanstack/react-table'
import { store } from 'store/index'

type Filter = {
  id: string
  label: string
  filters: ColumnFiltersState
}

// Make filters a function that returns the filters array, so store.nonNullCurrentUser
// is accessed lazily when the filters are actually used, not at module load time.
// This prevents the "Current user not present in store" error during bootstrapping.
export const getFilters = (): Filter[] =>
  (
    [
      {
        id: 'needs_action',
        label: 'Needs action from you',
        filters: [{ id: 'needsAction', value: true }],
      },
      {
        id: 'youre_assessing',
        label: "You're assessing",
        filters: [{ id: 'assessor', value: [store.nonNullCurrentUser.id] }],
      },
      {
        id: 'complete',
        label: 'Complete',
        filters: [{ id: 'progress', value: ['step_4'] }],
      },
      {
        id: 'incomplete',
        label: 'Incomplete',
        filters: [{ id: 'progress', value: ['step_1', 'step_2', 'step_3'] }],
      },
      {
        id: 'no_checkin',
        label: 'Not checked in',
        filters: [{ id: 'progress', value: ['not_created'] }],
      },
      (() => {
        // Resolve the label name for scaleValue=1 ("exceeding" equivalent) from the
        // user's last finalised checkin's scale — fully dynamic, no hardcoded string.
        const lastCheckin = store.checkins.lastFinalisedUserCheckin(
          store.nonNullCurrentUser.id
        )
        const aboveLabel =
          lastCheckin?.ratingScaleLabels?.find((l) => l.scaleValue === 1)
            ?.labelName ?? null

        if (!aboveLabel) return null

        return {
          id: 'above_expectation',
          label: aboveLabel,
          filters: [
            { id: 'checkinType', value: 'latest' },
            { id: 'progress', value: ['step_4'] },
            {
              id: 'finalLevel',
              value: [
                lastCheckin?.ratingScaleLabels?.find((l) => l.scaleValue === 1)
                  ?.labelSlug ?? aboveLabel,
              ],
            },
          ],
        }
      })(),
    ] as (Filter | null)[]
  ).filter((f): f is Filter => f !== null)
